// src/pages/usa/puertorico/Aguadilla.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Aguadilla ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Aguadilla() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Aguadilla, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Aguadilla, Puerto Rico</h2>

            <p>
              Aguadilla, located on the northwest coast of Puerto Rico, is a city rich in
              natural beauty. Known for its stunning beaches like Crash Boat, Survival
              Beach, and Peña Blanca, it offers crystal-clear waters and dramatic coastal
              cliffs that draw surfers, snorkelers, and sunset seekers alike. The lighthouse
              ruins in Punta Borinquen whisper stories of maritime history, standing watch
              over the Atlantic with quiet dignity. Whether you're exploring hidden sea
              caves or savoring fresh empanadillas by the shore, Aguadilla invites you to
              slow down and feel the rhythm of the island.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Aguadilla is easily accessible by car from San Juan via PR‑22, a scenic
              2‑hour drive along the northern coast. Travelers can also fly directly into
              Rafael Hernández Airport (BQN), located in Aguadilla itself. Public
              transportation exists, but renting a car is the best option for exploring the
              beaches, lighthouse ruins, and coastal trails.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Crash Boat:</strong> One of the most popular beaches in the
                  northwest, known for snorkeling, fishing, and sunsets. Its name comes
                  from World War II rescue boats once stationed here.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.458709541252095,-67.16397288774904"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Borinquen Point Lighthouse Ruins:</strong> Built in 1889 and
                  damaged by the 1918 earthquake, these ruins overlook the Atlantic and are
                  a favorite among photographers and hikers.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.48871108511742,-67.16152056887776"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Survival Beach Cave & Stairs:</strong> A dramatic shoreline with
                  massive rock formations and sea caves. The Survival Stairs, remnants of
                  the Ramey Air Force Base era, add historical charm.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.505094124392215,-67.14123530682242"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Surfer Beach (Parking)
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.50802626571729,-67.13578463474819"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Survival Beach Cave
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.506948693133268,-67.13419241978228"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Survival Beach Stairs
                  </a>
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Driving Around Aguadilla:</strong> Explore murals, plazas, and
                  ocean views. Head east toward Isabela for Guajataca Tunnel and Playa
                  Jobos, or inland to Moca and San Sebastián for coffee farms and mountain
                  breezes.
                </div>
              </li>
            </ul>

            <h3>🛏️ Places to Stay in Aguadilla</h3>

            <p>
              While I usually pass through Aguadilla on day trips, these well‑rated options
              are great for overnight stays. Always double‑check availability and reviews.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Punta Borinquen Resort:</strong> Near Survival Beach, with pool
                  and terrace.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Parador El Faro:</strong> Local favorite with restaurant, pool,
                  and family‑friendly atmosphere.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Courtyard by Marriott Aguadilla:</strong> Modern hotel with
                  pools, casino, and airport shuttle.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hotel Vista Azul:</strong> Sea‑view dining, lagoon pool, and
                  relaxed atmosphere.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Oceanfront Studio at Crash Boat:</strong> Direct beach access and
                  sunset views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Casa de Playa Aguadilla:</strong> Private terrace near Peña
                  Blanca Beach.
                </div>
              </li>
            </ul>

       <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I filmed in Aguadilla. Set the quality to 1080p or
              higher for best viewing.
            </p>

            <p>
              <a
                href="https://youtu.be/JGDeaDAwI5U?si=UhRPVc7NXP2rSRXO"
                target="_blank"
                rel="noopener noreferrer"
              >
                Survival Beach
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/KZB3xWJRzYY?si=qCTI5z_QaovUm34G"
                target="_blank"
                rel="noopener noreferrer"
              >
                Survival Beach Stairs
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/8LUQdI11vWU?si=QIVvSOVdc2KAX_J4"
                target="_blank"
                rel="noopener noreferrer"
              >
                Crash Boat
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/w94AuZdO088?si=UYWEasQonqY7IEyc"
                target="_blank"
                rel="noopener noreferrer"
              >
                Lighthouse Ruins
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/JGDeaDAwI5U?si=UhRPVc7NXP2rSRXO"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/aguadilla/survivalbeachcave.jpg"
                alt="Survival Beach"
              />
            </a>

            <a
              href="https://youtu.be/KZB3xWJRzYY?si=qCTI5z_QaovUm34G"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/aguadilla/survivalstairs.jpg"
                alt="Survival Beach Stairs"
              />
            </a>

            <a
              href="https://youtu.be/8LUQdI11vWU?si=QIVvSOVdc2KAX_J4"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/aguadilla/crashboat.jpg"
                alt="Crash Boat"
              />
            </a>

            <a
              href="https://youtu.be/w94AuZdO088?si=UYWEasQonqY7IEyc"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/aguadilla/lighthousesruins.jpg"
                alt="Lighthouse Ruins"
              />
            </a>

            <img
              src="/images/usa/puertorico/aguadilla/lighthouseruins1.jpg"
              alt="Lighthouse Ruins"
            />
            <img
              src="/images/usa/puertorico/aguadilla/sb.jpg"
              alt="Survival Beach"
            />
            <img
              src="/images/usa/puertorico/aguadilla/beach.jpg"
              alt="Survival Beach"
            />
            <img
              src="/images/usa/puertorico/aguadilla/town2.jpg"
              alt="Town of Aguadilla"
            />
            <img
              src="/images/usa/puertorico/aguadilla/town.jpg"
              alt="Town of Aguadilla"
            />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
